var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var generateError = function (message) { return "Relay SDK: ".concat(message); };
var SDK = /** @class */ (function () {
    function class_1(_fetch, id) {
        var _this = this;
        this.apiURL = 'https://relay-plantkit.vercel.app/api/';
        this.apiKey = '';
        this.id = '';
        this.init = function (data) {
            if (data.fetch) {
                _this.fetch = data.fetch;
            }
            if (data.apiURL) {
                _this.apiURL = data.apiURL;
            }
            if (data.apiKey) {
                _this.apiKey = data.apiKey;
            }
        };
        this.sendEvent = function (data, params) {
            var tags = params.tags, rest = __rest(params, ["tags"]);
            if (rest === null || rest === void 0 ? void 0 : rest.apiKey) {
                _this.init(__assign(__assign({}, rest), { apiKey: rest.apiKey }));
            }
            _this._validateSendEvent(data);
            var body = JSON.stringify({
                data: data,
                tags: (tags || []).concat([_this.id]),
            });
            return (_this.fetch || fetch)("".concat(_this.apiURL, "submissions/"), {
                body: body,
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-Key': _this.apiKey,
                },
                method: 'POST',
            }).then(function (res) { return res.json(); });
        };
        if (_fetch) {
            this.fetch = _fetch;
        }
        this.id = id;
        if (!this.fetch && typeof fetch === 'undefined') {
            console.error('Fetch function is undefined');
        }
        if (!this.id) {
            console.error('ID is undefined');
        }
    }
    class_1.prototype._validateSendEvent = function (data) {
        if (!data) {
            throw new Error(generateError('Attempting to send null data'));
        }
        if (!this.apiKey) {
            throw new Error(generateError('Attempting to send data with no API key, make sure you set it in sendEvent or init'));
        }
        if (!this.fetch && typeof fetch === 'undefined') {
            throw new Error(generateError('Attempting to send data with no API key, make sure you set it in sendEvent or init'));
        }
    };
    return class_1;
}());
export default function getSDKInstance(fetch, id) {
    var x = new SDK(fetch, id);
    return x;
}
